import { Switch } from "@/components/ui/switch"
import { Label } from "@/components/ui/label"
import { Home, User } from "lucide-react"
import { useUserMode } from "@/hooks/useUserMode"
import { useNavigate } from "react-router-dom"
import { cn } from "@/lib/utils"
import { useTranslation } from "react-i18next"

export const UserModeSwitch = () => {
  const { mode, setMode, canSwitchToHost } = useUserMode()
  const navigate = useNavigate()
  const { t } = useTranslation()
  
  if (!canSwitchToHost) {
    return null // Only show for approved hosts
  }
  
  const isHostMode = mode === 'host'
  
  const handleModeChange = (checked: boolean) => {
    const newMode = checked ? 'host' : 'guest'
    setMode(newMode)
    
    // Always navigate to home page, content changes based on mode
    navigate('/')
  }
  
  return (
    <div className="flex items-center gap-1 sm:gap-2 bg-muted/50 rounded-full p-0.5 sm:p-1 shrink-0">
      <div className={cn(
        "flex items-center gap-0.5 sm:gap-1 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-xs font-medium transition-all",
        !isHostMode ? "bg-background text-foreground shadow-sm" : "text-muted-foreground"
      )}>
        <User className="h-2.5 w-2.5 sm:h-3 sm:w-3" />
        <span className="hidden xs:inline sm:inline">{t('header.guest')}</span>
      </div>
      
      <Switch
        checked={isHostMode}
        onCheckedChange={handleModeChange}
        className="scale-[0.6] sm:scale-75"
        aria-label={t('header.switchMode')}
      />
      
      <div className={cn(
        "flex items-center gap-0.5 sm:gap-1 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-xs font-medium transition-all",
        isHostMode ? "bg-background text-foreground shadow-sm" : "text-muted-foreground"
      )}>
        <Home className="h-2.5 w-2.5 sm:h-3 sm:w-3" />
        <span className="hidden xs:inline sm:inline">{t('header.host')}</span>
      </div>
    </div>
  )
}